import './scss/app.scss'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import './filters'

import axios from 'axios'

import StackTrace from 'stacktrace-js'

import AppNotify from './app-notify';
import {ja} from 'date-fns/locale'
Vue.use(AppNotify)

Vue.config.productionTip = false

axios.interceptors.request.use((config) => {
    config['headers']['Content-Type'] = 'application/json';
    config['headers']['X-Requested-With'] = 'XMLHttpRequest';
    return config;
},
(error) => {
    return Promise.reject(error);
});

axios.interceptors.response.use((res) => {
    return res
},
async (error) => {
    return Promise.reject(error)
});

router.beforeEach(async (to, _from, next) => {
  // await store.dispatch('checkLogin')
  let user = store.state.user

  if ((!user) && (to.path != '/login' && to.path != '/register' && to.path != '/forgot-password' && to.path != '/reset-password')) {
    sessionStorage.after_login = to.path
    next('/login')
    return
  }
  else if (!!user && (to.path == '/login' || to.path == '/register' || to.path == '/forgot-password')) {
    next('/')
    return
  }
  else if (!!user && !user.superuser) {
    // console.log('yay', to)
    if (to.params.folder !== undefined) {
      try {
        await axios.get(`/api/files/${to.params.folder}`, {
          params: {
            fields: 'id,display_name,folder'
          },
        })
      }
      catch (ex) {
        store.dispatch('showRequestAccess', to.params.folder)
        return
      }
    }
  }

  //store folder options

  // if (to.fullPath != _from.fullPath) {
  //   console.log('store view options', to.fullPath, _from.fullPath)
  //   store.dispatch('setViewOptions', _from.fullPath)
  // }

  next()
})

// router.afterEach((to, _from) => {
//   //load folder options
//   
//   let path = to.fullPath
//   
//   if (!(path in store.state.viewOptions)) {
//     return;
//   }
//
//   let viewOpts = store.state.viewOptions[path]
//   console.log('load view options', to.fullPath, viewOpts.scrollPos)
//
//   Vue.nextTick().then(() => {
//     console.log('scrolling', viewOpts.scrollPos)
//     window.scrollTo(0, viewOpts.scrollPos)
//   })
//   store.dispatch('setSortMethod', viewOpts.sort)
//
// })

const notify = new AppNotify();
const app = new Vue({
    notify,
    router,
    store,
    render: h => h(App)
}).$mount('#app')


window.onerror = async (msg, source, lineno, colno, error) => {
  // console.error(error)
  
  let frames = await StackTrace.fromError(error)

  const data = {
    message: msg,
    frames: frames,
  }

  axios.post('/api/client-logger', data);
}

